import React, { ChangeEvent } from 'react';
import { inject, observer } from 'mobx-react';
import { PREPROJETO_STORE, PreProjetoStore, JustificativaReprovacaoValidator } from '../../Store';
import { RouteComponentProps } from 'react-router';
import { Button, withStateCard, Container, CardActions, Toast, ToastType, TutorialButtonAndBackButton } from '../../Components';
import styled from 'styled-components';
import DetalhesPreProjeto from './Components/DetalhesPreProjeto';
import { AUTH_STORE, AuthStore } from '../../Store/Auth';
import Tutorial_Professor from "../../Utils/Tutorial/Manual_do_portal_do_TCC_Professor.pdf";
import JustificativaDaReprovacaoModal from './Components/JustificativaDaReprovacaoModalPP';
import InstrucoesPreProjetoAceitoModal from './Components/InstrucoesPreProjetoAceitoModal';
import { GlobalErrorToast } from '../Shared/GlobalErrorToast';
import PageSubTitle from "../../Components/PageSubTitle";

/*
  interfaces
*/
interface IProps extends RouteComponentProps<{ id: string }> {
  [PREPROJETO_STORE]: PreProjetoStore;
  [AUTH_STORE]: AuthStore;

}

interface IState {
  modalIsOpen: boolean;
  modalAceiteIsOpen: boolean;
}

const ContainerWithState = styled(withStateCard(Container))`
  display: grid;
  padding: 0;
  justify-content: normal;
`;

const StyledCardActions = styled(CardActions)`
  padding: 12px 24px;

  button {
    margin-left: 15px;
  }
`;

const StyledText = styled.span`
  padding: 5px;
`;


@inject(PREPROJETO_STORE, AUTH_STORE)
@observer
export default class PreProjetoPage extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      modalIsOpen: false,
      modalAceiteIsOpen: false
    };
  }

  componentDidMount() {
    const preprojetoStore = this.props[PREPROJETO_STORE];
    preprojetoStore.recuperarInformacoesPreProjeto(
      parseInt(this.props.match.params.id)
    );
    preprojetoStore.getFaseAtual()
  }

  onResumeClick = () => {
    window.open(Tutorial_Professor);
  }

  preProjetoAprovar = async () => {
    const preProjetoStore = this.props[PREPROJETO_STORE];
    const { setValidationError } = preProjetoStore

    setValidationError({});
    await preProjetoStore.ppAprovar();
    if (!preProjetoStore.preProjetoValidationError!.global) {
      var { history } = this.props;
      history.push(`/professor`);
    }
    this.setState({ modalAceiteIsOpen: false });
  }

  openModalJustificativa = () => {
    const store = this.props[PREPROJETO_STORE];
    store.updateField('justificativaReprovacao', '');
    this.setState({ modalIsOpen: true });
  }

  handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const store = this.props[PREPROJETO_STORE]
    const { name, value } = event.target
    store.updateAttribute(name, value)
  }

  preProjetoReprovar = async () => {
    const preProjetoStore = this.props[PREPROJETO_STORE];
    const { justificativaReprovacao, setJustificativaError, setValidationError } = preProjetoStore;

    const errors = JustificativaReprovacaoValidator.getErrors({ justificativaReprovacao });
    setJustificativaError(errors);

    if (!errors) {
      var { history } = this.props;
      setValidationError({});
      await preProjetoStore.ppReprovar();
      history.push(`/professor`);
      this.setState({ modalIsOpen: false });
    }
  };

  render() {
    const { [PREPROJETO_STORE]: preProjetoStore } = { ...this.props };
    const { history } = this.props;
    const {
      orientandosState,
      preProjetoState,
      orientacao,
      justificativaReprovacao,
      justificativaReprovacaoValidationError,
      vagasRestantes,
      faseAtual,
      preProjetoValidationError
    } = preProjetoStore;

    return (
      <>
        <PageSubTitle subTitle={'Seleção de Orientandos - Análise de Pré-Projetos'} />
        <TutorialButtonAndBackButton
          openTutorial={this.onResumeClick}
          voltar={() => history.push('/professor')}
        />
        <ContainerWithState state={orientandosState && preProjetoState}>
          <GlobalErrorToast messages={preProjetoValidationError && preProjetoValidationError.global} />
          {orientacao && orientacao.conviteAceito === true &&
            <Toast type={ToastType.success}>
              <StyledText>
                <strong>Orientação aceita na {orientacao.ordemParaConvite}ª fase</strong>
              </StyledText>
            </Toast>}

          {orientacao && orientacao.conviteAceito === false &&
            <Toast type={ToastType.error}>
              <StyledText>
                <strong>Orientação não aceita.</strong>
              </StyledText>
            </Toast>}

          {vagasRestantes <= 0 &&
            <Toast type={ToastType.warning}>
              <StyledText>
                <strong>Sua cota de 10 orientandos já foi atingida.</strong>
              </StyledText>
            </Toast>}

          {vagasRestantes > 0 &&
            <Toast type={ToastType.warning}>
              <StyledText>
                {/* <strong>Você possui {vagasRestantes} vagas de orientação. Analise o pré-projeto e decida se aceita ou não aceita a orientação.</strong> */}
                <strong>Você pode escolher até 10 projetos para orientação. Analise o pré-projeto e decida se aceita ou não aceita a orientação.</strong>
              </StyledText>
            </Toast>}

          <DetalhesPreProjeto orientacao={orientacao} />
          {faseAtual && orientacao && faseAtual == orientacao.ordemParaConvite &&
            <StyledCardActions>
              <Button
                color='approvedColor'
                onClick={() => this.setState({ modalAceiteIsOpen: true })}>
                Aceitar
              </Button>
              <Button
                color='errorColor'
                onClick={() => this.openModalJustificativa()}>
                Não Aceitar
              </Button>
            </StyledCardActions>
          }
        </ContainerWithState>

        <JustificativaDaReprovacaoModal
          isOpen={this.state.modalIsOpen}
          outterClick={() => this.setState({ modalIsOpen: false })}
          texto={justificativaReprovacao}
          onTextChange={this.handleChange}
          reprovar={this.preProjetoReprovar}
          errors={justificativaReprovacaoValidationError}
        />

        <InstrucoesPreProjetoAceitoModal
          isOpen={this.state.modalAceiteIsOpen}
          outterClick={() => this.setState({ modalAceiteIsOpen: false })}
          aprovar={this.preProjetoAprovar}
        />
      </>
    );
  }
}
